let config = {
  origin: "",
  bsvTxidUrl: "http://bsv.mempool.com/TransactionDetail/",
  btcTxidUrl: "http://btc.mempool.com/w/TransactionDetails/",

  // 登录模块
  loginUrl: `/userService/userAuth`,
  userLogout: `/userService/userLogout`,
  register: `/user/register`,
  getVerifyCode: `/user/getVerifyCode`,
  resetConfirm: `/userService/resetConfirm`,
  // resetPassword: `/userService/resetPassword`,
  //公开模块
  getBanner: "/getBanner",
  getArticleList: `/article/getArticleList`,
  getZeroRate: `/userService/getMainUserIsZeroRate`, //0费率活动接口； 2020.3.16-2020.4.15

  //用户设置
  setWithdrawAddrSms: "/user/setWithdrawAddrSms",
  setWithdrawAddr: "/user/setWithdrawAddr",
  getLoginLog: "/userService/getLoginLog",
  findUser: "/userService/findUser",
  setTimeZone: "/user/setTimeZone",
  editUser: "/userService/editUser",
  getGoogleAuthQrcode: "/userService/getGoogleAuthQrcode",
  turnOnGoogleAuth: "/userService/turnOnGoogleAuth",
  turnOffGoogleAuth: "/userService/turnOffGoogleAuth",
  //资金管理
  getTotalFunds: "/finance/getTotalFunds",
  getLast24HoursProfit: "/userService/getLast24HoursProfit",
  getTotalWithdrawableAmount: `/userService/getTotalWithdrawableAmount`, //累计收益（旧）
  getTotalProfit: `/finance/getTotalProfit`, //累计收益（v3.1 新）
  setAutoWithdrawAmount: `/userService/setAutoWithdrawAmount`,
  setAutoMoneyExchange: `/userService/setAutoMoneyExchange`,
  getFundSummary: `/finance/getMainUserMoney`,
  //共享费率
  // changeRatetDay: "/user/changeRatetDay",
  // changeRateHour: "/user/changeRateHour",
  // changeRateMinute: "/user/changeRateMinute",
  changeRatetDay: "/bsv2BtcRate/day",
  changeRateHour: "/bsv2BtcRate/hour",
  changeRateMinute: "/bsv2BtcRate/minute",
  poolAccountList: "/poolAccount/poolAccountList",
  userAccountList: "/poolAccount/userAccountList",
  listWithdraw: "/user/listWithdraw", //提现记录
  getBalance: "/user/getBalance", //账户余额
  getAllBalance: "/poolAccount/getAllBalance", //余额汇总
  userNewAddress: "/poolAccount/getUserNewAddr", //获取注资地址
  setUserAccountapply: "/poolAccount/setUserAccountapply",
  getWithDrawBalance: "/poolAccount/getWithdrawBalance", //提现余额
  getWithdrawBSVFee: "/user/getWithdrawHandleFeeBsv", //BSV手续费
  getWithdrawBTCFee: "/user/getWithdrawHandleFee", //BTC手续费
  getBlock: "/fundpool/getBlockList", //出块统计
  getPoolAmount: "/fundpool/getBalanceSnapshot", //资金快照

  // 用户面板
  summary: "/userService/getSummary", //概要
  subUserListIndex: "/userService/subUserListIndex", // 所有账户列表（包含主账户）
  addSubUser: "/userService/addSubUser", //新增子账户
  coinEarn: "/userService/getBtcTranEarn", //收益预估
  listManualRec: "/user/listManualRec", //补帐列表

  // 子账户
  // editSub: "/userService/editSubUser", //更换默认子账户
  // getDefaultSubAccount: "/userService/defaultSub", //获取子账户详情
  getSubSummary: "/userService/getSubSummary", //子账户汇总
  listEarn: "/user/listEarn", //收益记录
  listExchange: "/user/listExchange", //换币记录
  subUserList: "/userService/subUserList", //子账户排序
  workerList: "/user/listWorkers", //矿工列表
  workerGroup: "/userService/getWorkerGroupList", //矿工分组
  addGroup: "/userService/addWorkerGroup", //新增矿工分组
  editGroup: "/userService/modifyWorkerGroup", //编辑矿工分组
  delGroup: "/userService/deleteWorkerGroup", //删除矿工分组
  delOffline: "/user/deleteOfflineWorker", //清空离线矿工
  moveMiner: "/userService/addWorkerToGroup", //移动矿工至分组
  getObserverKey: "/userService/getSubuserAuthKey", //获取观察者key
  getOberverList: "/userService/getSubuserAuthList", //获取已授权的观察者
  setMining: "/subuser/setMining", //挖矿设置
  getRate: "/user/showExchangeRelate", //获取换币汇率
  saveExchange: "/user/saveBtcExchangeBsvOrder", //btc换bsv
  setMonitor: "/userService/setMonitor", //监控设置
  setObserver: "/userService/setSubuserAuth", //设置观察者
  delObserver: "/userService/delSubuserAuth", //删除观察者
  setSubuserWithdrawAddr: "/user/setSubuserWithdrawAddr", //子账号提现地址设置
  setWithdraw: "/subuser/setWithdraw",
  setExchange: "/subuser/setExchange",
  withDrawApply: "/poolAccount/setUserAccountapply", //资金池申请提现
  withDrawMainApply: "/user/setWithdrawApply", //主账户提现
  subWithDrawSingle: "/user/setWithdrawApplySubUser", //子账号申请提现
  subWithDraw: "/subuser/batchWithdraw", //子账户批量提现
  switchList: "/user/userAutoSwitchHistory", //智能切换列表
  autobtcList: "/userService/userAutoBsv2BtcList", //bsv2btc兑换记录

  // 代理管理
  getAgentList: "/userService/childUserList", //获取代理账号列表
  getProfit: "/userService/getProfit", //获取收益
  editAgent: "/userService/editChildUser", //修改代理设置
  //代理创建
  addUser: "/userService/addUser",

  // 计算器
  getComputing: "/sta/getEffectiveComputing",

  //主页
  staWorkNumHDay: "/user/staWorkNumHDay",
  staWorkNumHour: "/user/staWorkNumHour", //矿工chart
  staCalculDay: "/user/staCalculDay", //收益chart
  staCalculHour: "/user/staCalculHour", //算力chart
  // getProfitGraphic: "/stats/getProfitGraphic", //获取每日收益图表数据
  // getHashGraphic: "/stats/getHashGraphic", //获取每日算力图表

  staWorkNum: "/user/staWorkNum", //v3.7.2 矿工chart
  getProfitGraphic: "/stats/getProfitGraphic", //v3.7.2 获取每日收益图表数据
  getHashGraphic: "/stats/getHashGraphic", //v3.7.2 获取每日算力图表

  // 观察者
  subuserListAuth: "/userService/subuserListAuth", //观察子账户
  defaultSubuserAuth: "/userService/getDefaultSubuserAuth", //观察默认子账户

  // 报表
  electricCharge: "/user/getElectricCharge", //电费统计
  minerWorkTime: "/user/getWorkerRuntimeList", //运行时长统计

  //月账单
  getWorkerBillList: "/user/getWorkerBillList", //获取月账单列表
  getBillEmail: "/user/getBillEmail", //获取月账单邮箱
  setBillMailAddr: "/user/setBillMailAddr", //设置月账单提现地址
  //common接口
  article: `/api/common/article`,
  banner: `/api/common/banner`,

  //矿机列表
  // getBchPrice: `https://bch-chain.api.btc.com/v3/block/latest`,
  getBchPrice: `/api/bch`,
  // findMachine: "https://mining.mempool.com/findMachine",
  findMachine: "/api/findMachine",
  getDayEarn: "/sta/getDayEarn",
  getOneAppVersion: "/version/getOneAppVersion",
  // v3.5
  getLoanList: "/user/listLoanRepay",
  setLanguage: "/user/setLanguage",
  // v3.7.5
  getAverageFee: "/subuser/batchWithdrawGetFee",
  // v3.7.7
  setHidden: "/subuser/setHidden",
  // v3.8.0
  walletAuth: "/userService/ddpurseUserAuth",
  getcode: `http://192.168.0.2:6001/v1/codes`,
  getSetting: "/userService/getSubUserSetting",
  getSubUserInfo: "/userService/getSubUserInfo",
  getFee: "/user/getWithdrawHandleFee",
};

export default config;
